// src/admin/components/SettingsTable.jsx
import React from "react";
import "./SettingsTable.css";
import { FaEdit, FaTrash } from "react-icons/fa";

const SettingsTable = ({ settingsList, onEdit, onDelete, canWrite = true }) => {
  if (!settingsList || settingsList.length === 0) {
    return (
      <div className="no-settings-message">
        <p>No site settings found. Please create one.</p>
      </div>
    );
  }

  return (
    <div className="settings-table-container">
      <table className="settings-table">
        <thead>
          <tr>
            <th>Site Name</th>
            <th>Site URL</th>
            <th>Platform Fee</th>
            <th>Contact Details</th>
            <th>Social Links</th>
            <th>Actions</th>
          </tr>
        </thead>
        <tbody>
          {settingsList.map((settings) => (
            <tr key={settings.id || settings._id}>
              <td style={{ fontWeight: 600 }}>{settings.site_name}</td>
              <td style={{ color: "#007bff" }}>{settings.site_url}</td>
              <td>
                <span className="platform-fee-badge">
                  ₹{settings.platform_fee}
                </span>
              </td>
              <td>
                <div className="contact-info-cell">
                  <span className="email">{settings.contact_email}</span>
                  <span className="phone">{settings.contact_phone}</span>
                  <span className="address" title={settings.address}>
                    {settings.address.substring(0, 30)}...
                  </span>
                </div>
              </td>
              <td>
                <div className="social-icons-cell">
                  {settings.social_links?.facebook && <span className="social-badge">FB</span>}
                  {settings.social_links?.twitter && <span className="social-badge">TW</span>}
                  {settings.social_links?.instagram && <span className="social-badge">IG</span>}
                  {settings.social_links?.linkdin && <span className="social-badge">LI</span>}
                  {settings.social_links?.youtube && <span className="social-badge">YT</span>}
                  {!settings.social_links && "N/A"}
                </div>
              </td>
              <td>
                <div className="action-buttons">
                  {canWrite && (
                    <>
                      <button
                        className="btn-edit"
                        onClick={() => onEdit(settings)}
                        title="Update Settings"
                      >
                        <FaEdit />
                      </button>
                      <button
                        className="btn-delete"
                        onClick={() => onDelete(settings.id || settings._id)}
                        title="Delete Settings"
                      >
                        <FaTrash />
                      </button>
                    </>
                  )}
                </div>
              </td>
            </tr>
          ))}
        </tbody>
      </table>
    </div>
  );
};

export default SettingsTable;
